(function ($, Global) {
    var urlParams = new UrlParams();
    function ArchiveModel() {
        // Déclaration class objet
    }

	ArchiveModel.prototype.updateEdition = function (val, filterName) {
        if (filterName == 'Publication') {

            urlParams.setParam('Year', '');
            urlParams.setParam('Month', '');
            urlParams.setParam('Issue', '');
        } else if (filterName == 'Year') {

            urlParams.setParam('Month', '');
            urlParams.setParam('Issue', '');
        } else if (filterName == 'Month') {

            urlParams.setParam('Issue', '');
        }

		urlParams.setParam(filterName, val);
		document.location.reload();
	}

	Global.ArchiveModel = ArchiveModel;
}(jQuery, window));